export function createVehicleClient(transport) {
    return {
        /**
         * POST /v1/vehicles
         *
         * Requires scope: vehicle:create
         */
        createVehicle(body, options) {
            return transport.request({
                method: "POST",
                path: "/v1/vehicles",
                body,
                options,
            });
        },
        /**
         * GET /v1/vehicles/{vehicleId}
         *
         * Requires scope: vehicle:read, vehicle:self
         */
        getVehicle(vehicleId, options) {
            return transport.request({
                method: "GET",
                path: `/v1/vehicles/${encodeURIComponent(vehicleId)}`,
                options,
            });
        },
        /**
         * PATCH /v1/vehicles/{vehicleId}
         *
         * Requires scope: vehicle:update
         */
        updateVehicle(vehicleId, body, options) {
            return transport.request({
                method: "PATCH",
                path: `/v1/vehicles/${encodeURIComponent(vehicleId)}`,
                body,
                options,
            });
        },
        /**
         * A vehicle's seat layout
         *
         * Requires scope: vehicle:read, vehicle:self
         */
        getVehicleSeats(vehicleId, options) {
            return transport.request({
                method: "GET",
                path: `/v1/vehicles/${encodeURIComponent(vehicleId)}/seats`,
                options,
            });
        },
        /**
         * Replace a vehicle's seat layout
         *
         * Requires scope: vehicle:update
         */
        replaceVehicleSeats(vehicleId, body, options) {
            return transport.request({
                method: "PUT",
                path: `/v1/vehicles/${encodeURIComponent(vehicleId)}/seats`,
                body,
                options,
            });
        },
        /**
         * Record one of the vehicle's own documents, with its type and expiry
         *
         * Requires scope: vehicle:document:write
         */
        recordVehicleDocument(vehicleId, documentId, body, options) {
            return transport.request({
                method: "PUT",
                path: `/v1/vehicles/${encodeURIComponent(vehicleId)}/documents/${encodeURIComponent(documentId)}`,
                body,
                options,
            });
        },
        /**
         * Assign a driver to this vehicle
         *
         * Requires scope: vehicle-assignment:self, vehicle-assignment:write
         */
        assignVehicle(vehicleId, body, options) {
            return transport.request({
                method: "POST",
                path: `/v1/vehicles/${encodeURIComponent(vehicleId)}/assignments`,
                body,
                options,
            });
        },
        /**
         * End an assignment, which is how a reassignment begins
         *
         * Requires scope: vehicle-assignment:self, vehicle-assignment:write
         */
        endVehicleAssignment(vehicleId, assignmentId, body, options) {
            return transport.request({
                method: "POST",
                path: `/v1/vehicles/${encodeURIComponent(vehicleId)}/assignments/${encodeURIComponent(assignmentId)}/end`,
                body,
                options,
            });
        },
        /**
         * The vehicles assigned to one driver, newest first
         *
         * Requires scope: vehicle-assignment:read, vehicle-assignment:self
         */
        listDriverVehicleAssignments(driverId, limit, after, options) {
            return transport.request({
                method: "GET",
                path: `/v1/drivers/${encodeURIComponent(driverId)}/vehicle-assignments`,
                query: { limit: limit, after: after },
                options,
            });
        },
        /**
         * Answer whether this vehicle may be part of an approved onboarding
         *
         * Requires scope: vehicle:eligibility
         */
        getTenantsReferencesEligibility(tenantId, referenceId, options) {
            return transport.request({
                method: "GET",
                path: `/v1/tenants/${encodeURIComponent(tenantId)}/references/${encodeURIComponent(referenceId)}/eligibility`,
                options,
            });
        },
        /**
         * Report this service's identity and declared implementation status
         */
        getServiceInfo(options) {
            return transport.request({
                method: "GET",
                path: "/v1/service-info",
                options,
            });
        },
    };
}
//# sourceMappingURL=vehicle.js.map